import { localStorage } from '@/utils/storage'
import { localStorageKeys } from '@/common/storage-keys'

/**
 * @description Set token đăng nhập vào localStorage
 * @param {String} token
 * @author PHNam
 */
const setAuthToken = (token: string) => {
  // Check điều kiện trước khi cất để tránh trường hợp lưu vào là giá trị null nhưng lấy ra lại là "null" (PVThang)
  if (token) {
    localStorage.set(localStorageKeys.TOKEN, token)
  }
}

/**
 * @description Get token đăng nhập từ localStorage
 * @author PHNam
 */
const getAuthToken = () => {
  return localStorage.get(localStorageKeys.TOKEN)
}

/**
 * @description Xóa token đăng nhập từ localStorage
 * @author PHNam
 */
const removeAuthToken = () => {
  localStorage.remove(localStorageKeys.TOKEN)
}

/**
 * @description Set kiểu người dùng vào localStorage
 * @param {String} token
 * @author PVThang
 */
const setUserType = (userType: number) => {
  localStorage.set(localStorageKeys.USER_TYPE, userType)
}

/**
 * @description Get kiểu người dùng từ localStorage
 * @author PVThang
 */
const getUserType = (): number | undefined => {
  return localStorage.get(localStorageKeys.USER_TYPE)
}

/**
 * @description Xóa kiểu người dùng từ localStorage
 * @author PVThang
 */
const removeUserType = () => {
  localStorage.remove(localStorageKeys.USER_TYPE)
}

export { setAuthToken, getAuthToken, removeAuthToken, setUserType, getUserType, removeUserType }
